import * as vuex from 'vuex-class';
import { IEditorUiState } from '@/editor/editor-block/store/editor-ui.types';

export const namespace: string = 'editorUi';

export const editorUiNamespace: string = 'editor/editorUi';

export const EditorUi = vuex.namespace(editorUiNamespace);

export enum EEditorUiAction {
  SetSelection = 'setSelection',
  ResetSelection = 'resetSelection',
  UpdateTextMenuState = 'updateTextMenuState',
  UpdateImageMenuState = 'updateImageMenuState',
  TriggerMenuCommand = 'triggerMenuCommand',
  CreateImage = 'createImage',
  CreateImageSuccess = 'createImageSuccess',
  CreateImageFailed = 'createImageFailed',
  ResetCreateImage = 'resetCreateImage',
}

export enum EEditorUiMutation {
  SetSelection = 'setSelection',
  ResetSelection = 'resetSelection',
  UpdateTextMenuState = 'updateTextMenuState',
  UpdateImageMenuState = 'updateImageMenuState',
  TriggerMenuCommand = 'triggerMenuCommand',
  SetImageUploaded = 'setImageUploaded',
  SetImageUploading = 'setImageUploading',
  SetImageUploadFailed = 'setImageUploadFailed',
  ResetImageUpload = 'resetImageUpload',
}

export const state: IEditorUiState = {
  selected: {
    nodeId: '',
    cellId: '',
    rowId: '',
    sectionId: '',
    documentPageId: '',
  },
  textMenuState: {
    bold: false,
    italic: false,
    underline: false,
    link: false,
    paragraph: false,
    heading1: false,
    heading2: false,
    subHeading: false,
    label: false,
    bulletList: false,
    orderedList: false,
    alignLeft: false,
    alignCenter: false,
    alignRight: false,
    alignJustify: false,
    listToggle: false,
    undo: false,
    redo: false,
    mergeTagId: '',
    linkUrl: '',
  },
  imageMenuState: {
    heading: false,
    caption: false,
  },
  menuCommand: undefined,
  imageUpload: {
    imageUploaded: undefined,
    imageUploadFailed: false,
    isUploading: false,
    documentPageId: undefined,
  },
};
